import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import errorReportIcon from '@fortawesome/fontawesome-free-solid/faExclamation'

import { Radio } from '../../../kevinsLegacy'
import { TextInput, Button, CircularProgress } from '../../../common'
import MenuHeader from '../../../containers/MenuHeader'
import OfflineModeHeader from '../../../containers/OfflineModeHeader'

import * as Constants from '../../../../helpers/Constants'
import * as Styles from './styles'
import * as Strings from './strings'
import * as userActions from '../../../../actions/User'
import * as errorReportsActions from '../../../../actions/ErrorReports'
import * as configActions from '../../../../actions/Config'
import * as offlineModeActions from '../../../../actions/OfflineMode'

class NewErrorReport extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageInput: '',
      subjectInput: '',
      criticalStatus: 1,
      location: null,
      width: window.innerWidth
    }
    this.resizeHandler = this.resizeHandler.bind(this)
  }

  componentDidMount() {
    const { history, user, offlineMode } = this.props
    if (offlineMode) {
      if (!user.offlineModeSignedIn) {
        this.props.setOfflineSetup()
      }
    } else if (!user.fetched) {
      history.push('/')
    }
    window.addEventListener('resize', this.resizeHandler)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeHandler)
  }

  resizeHandler() {
    this.setState({ width: window.innerWidth })
  }

  onSuccess() {
    const { config } = this.props

    this.setState({
      messageInput: '',
      subjectInput: '',
      criticalStatus: 1,
      location: null
    })

    this.props.showAlert(
      Strings.default.ERROR_REPORT_SEND[config.language],
      Strings.default.ERROR_REPORT_SEND_INFO[config.language],
      Constants.ONE_BUTTON,
      { title: Strings.default.OK[config.language], onPress: () => {} }
    )
  }

  create() {
    const { subjectInput, messageInput, criticalStatus, location } = this.state
    const { user, config, offlineMode, data } = this.props
    if (subjectInput === '') {
      this.props.showAlert(
        Strings.default.MISSING_SUBJECT[config.language],
        Strings.default.MISSING_SUBJECT_INFO[config.language],
        Constants.ONE_BUTTON,
        { title: Strings.default.OK[config.language], onPress: () => {} }
      )
    } else if (messageInput === '') {
      this.props.showAlert(
        Strings.default.MISSING_MESSAGE[config.language],
        Strings.default.MISSING_MESSAGE_INFO[config.language],
        Constants.ONE_BUTTON,
        { title: Strings.default.OK[config.language], onPress: () => {} }
      )
    } else if (location === null) {
      this.props.showAlert(
        Strings.default.MISSING_LOCATION[config.language],
        Strings.default.MISSING_LOCATION_INFO[config.language],
        Constants.ONE_BUTTON,
        { title: Strings.default.OK[config.language], onPress: () => {} }
      )
    } else {
      const postData = {
        title: subjectInput,
        message: messageInput,
        senderApartment: data.apartment.number,
        senderEmail: data.user.email,
        criticalStatus,
        location
      }

      if (!offlineMode) {
        this.props.trySendErrorReportEmail(
          user.token,
          postData,
          config.language,
          () => this.onSuccess(),
          (h, i, t, b) => this.props.showAlert(h, i, t, b)
        )
      } else {
        this.onSuccess()
      }
    }
  }

  renderLocation() {
    const { config } = this.props
    const { location } = this.state
    const radioButtons = []
    const locations = [
      Strings.default.MY_APARTMENT[config.language],
      Strings.default.COMMON_AREA[config.language],
      Strings.default.OUTDOORS[config.language],
      Strings.default.OTHER[config.language]
    ]

    const ids = [
      Constants.MY_APARTMENT,
      Constants.COMMON_AREA,
      Constants.OUTSIDE,
      Constants.OTHER
    ]

    for (let i = 0; i < 4; i++) {
      radioButtons.push(
        <Radio
          selected={location === ids[i]}
          onClick={() => this.setState({ location: ids[i] })}
          style={{ marginTop: 5 }}
          title={locations[i]}
          titlePosition={'right'}
          color={Constants.WHITE_LABEL.colors.primary}
          hoverColor={Constants.WHITE_LABEL.colors.primaryHover}
        />
      )
    }

    return radioButtons
  }

  renderUrgentScale() {
    const { criticalStatus } = this.state
    const radioButtons = []

    for (let i = 1; i < 11; i++) {
      let color = Constants.WHITE_LABEL.colors.primary
      let hoverColor = Constants.WHITE_LABEL.colors.primaryHover
      if (i > 5) {
        color = Constants.WHITE_LABEL.colors.warning
        hoverColor = Constants.WHITE_LABEL.colors.warningHover
      }

      radioButtons.push(
        <Radio
          selected={criticalStatus === i}
          onClick={() => this.setState({ criticalStatus: i })}
          color={color}
          hoverColor={hoverColor}
          title={i}
        />
      )
    }

    return radioButtons
  }

  renderContent() {
    const { messageInput, subjectInput, width } = this.state
    const { user, config, errorReport, offlineMode } = this.props

    if (!user.fetched) {
      return <CircularProgress />
    }

    if (user.fetched || user.offlineModeSignedIn) {
      return (
        <div style={Styles.default.containerStyle}>
          {width < 800 ? null : (
            <div
              style={{
                ...Styles.default.informationContainerStyle,
                paddingTop: offlineMode ? 168 : 128
              }}
            >
              <FontAwesomeIcon
                icon={errorReportIcon}
                style={{ fontSize: 40 }}
                color={Constants.WHITE_LABEL.colors.lightText}
              />
              <h2
                className={'centerText'}
                style={{
                  ...Styles.default.headerStyle,
                  color: Constants.WHITE_LABEL.colors.lightText
                }}
              >
                {Strings.default.REPORT_AN_ERROR[config.language]}
              </h2>
              <p className={'centerText'} style={Styles.default.textStyle}>
                {Constants.WHITE_LABEL.strings.errorReport[config.language]}
              </p>
            </div>
          )}
          <div style={Styles.default.newErrorReportContainerStyle}>
            <TextInput
              maxWidth={350}
              width={'80%'}
              header={Strings.default.SUBJECT[config.language]}
              value={subjectInput}
              onChange={text => this.setState({ subjectInput: text })}
            />
            <TextInput
              maxWidth={350}
              width={'80%'}
              header={Strings.default.MESSAGE[config.language]}
              value={messageInput}
              onChange={text => this.setState({ messageInput: text })}
            />
            <div style={Styles.default.radioButtonsContainerStyle}>
              <p style={Styles.default.placeholderStyle}>
                {Strings.default.HOW_URGENT_IS_IT[config.language]}
              </p>
              <div style={Styles.default.criticalStatusContainerStyle}>
                {this.renderUrgentScale()}
              </div>
            </div>
            <div style={Styles.default.radioButtonsContainerStyle}>
              <p style={Styles.default.placeholderStyle}>
                {Strings.default.WHERE_IS_THE_ERROR[config.language]}
              </p>
              <div style={Styles.default.locationContainerStyle}>
                {this.renderLocation()}
              </div>
            </div>
            <Button
              header={Strings.default.SEND[config.language]}
              className={'primary'}
              width={'80%'}
              maxWidth={350}
              marginTop={40}
              marginBottom={40}
              onClick={() => this.create()}
              loading={errorReport.isCreating}
              color={Constants.WHITE_LABEL.colors.primary}
              hoverColor={Constants.WHITE_LABEL.colors.primaryHover}
            />
          </div>
        </div>
      )
    }
  }

  render() {
    const { history, user, config, offlineMode } = this.props

    if (!user.fetched && !offlineMode) {
      history.push('/')
      return <CircularProgress />
    }

    return (
      <MenuHeader
        selected={Constants.REPORT_AN_ERROR_FOCUSED}
        history={history}
        header={Strings.default.NEW_ERROR_REPORT[config.language]}
      >
        <div className={'ContainerCenteredWhite'} style={{ minHeight: '100%' }}>
          <OfflineModeHeader history={history} />
          {this.renderContent()}
        </div>
      </MenuHeader>
    )
  }
}

function mapStateToProps({ user, errorReport, config, data }) {
  return { user, errorReport, config, data }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...userActions,
      ...errorReportsActions,
      ...offlineModeActions,
      ...configActions
    },
    dispatch
  )
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NewErrorReport)



// WEBPACK FOOTER //
// ./src/components/pages/errorReports/NewErrorReport/index.js